import {
  getEnabledElement,
  getEnabledElementById,
  updateEnabledElementById,
} from "component/toolManager/enabledElements.js";
import { updateEnabledElement } from "component/toolManager/enabledElements.js";
import triggerEvent from "core/customEvent/triggerEvent";
import Helper from "helper";

/**
 *
 */
export default function (synchronizer, sourceElement, targetElement) {
  // Ignore the case where the source and target are the same enabled element
  if (targetElement === sourceElement) {
    return;
  }

  // Element 정보 획득
  let sourceElementStub = getEnabledElement(sourceElement);
  let targetElementStub = getEnabledElement(targetElement);

  // Get the source and target viewports
  const sourceViewport = sourceElementStub.viewport;
  const targetViewport = targetElementStub.viewport;
  if (!!sourceViewport === false || !!targetViewport === false) {
    return;
  }

  // Do nothing if the ww/wc already match
  if (
    targetViewport.voi.windowWidth === sourceViewport.voi.windowWidth &&
    targetViewport.voi.windowCenter === sourceViewport.voi.windowCenter &&
    targetViewport.invert === sourceViewport.invert
  ) {
    return;
  }

  // Www/wc are different, sync them
  targetViewport.voi.windowWidth = sourceViewport.voi.windowWidth;
  targetViewport.voi.windowCenter = sourceViewport.voi.windowCenter;
  targetViewport.invert = sourceViewport.invert;
  targetElementStub.needsRedraw = true;

  updateEnabledElement(sourceElementStub);
  updateEnabledElement(targetElementStub);

  triggerEvent(targetElementStub.element, "setState");
}
